"use strict";

import { VOICE_SAMPLES } from "../../ApiEndpoints.js";
import { postWithFirebaseAuth } from "../../utils/firebaseApiClient.js";

/**
 * A playable sample of one of a character's voices, saying one of their own
 * lines. The server makes it on first request and reuses it afterwards.
 */
export const getVoiceSample = async ({
  projectId,
  languageCode,
  speakerId,
  voiceId,
}) => {
  const response = await postWithFirebaseAuth(
    `${VOICE_SAMPLES}/${encodeURIComponent(projectId)}/voice-samples`,
    { languageCode, speakerId, voiceId }
  );
  return response.data;
};
